/* eslint-disable no-inline-styles/no-inline-styles */
import React, { Component } from 'react';

import { ClickableComponent } from '@schoolinks/ui-components';
import cn from 'classnames';
import { isEqual, isEmpty } from 'lodash';
import { shape, bool, string, func, node, number } from 'prop-types';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { withState } from 'recompose';
import { bindActionCreators } from 'redux';

import { faBars } from '@fortawesome/pro-regular-svg-icons/faBars';
import { faBell } from '@fortawesome/pro-regular-svg-icons/faBell';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import { faCircleQuestion } from '@fortawesome/pro-regular-svg-icons/faCircleQuestion';
import { faComment } from '@fortawesome/pro-regular-svg-icons/faComment';
import { faEllipsisVertical } from '@fortawesome/pro-regular-svg-icons/faEllipsisVertical';
import { faEnvelope } from '@fortawesome/pro-regular-svg-icons/faEnvelope';
import { faFile } from '@fortawesome/pro-regular-svg-icons/faFile';
import { faGear } from '@fortawesome/pro-regular-svg-icons/faGear';
import { faGraduationCap } from '@fortawesome/pro-regular-svg-icons/faGraduationCap';
import { faWallet } from '@fortawesome/pro-regular-svg-icons/faWallet';

import AppBar from '@mui/material/AppBar';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';
import Toolbar from '@mui/material/Toolbar';

import ButtonLink from 'components/Common/Buttons/ButtonLink';
import Button from 'components/Common/Buttons/ButtonV3';
import Flexbox from 'components/Common/Flexbox';

import FontAwesomeIcon from 'components/Common/FontAwesomeIcon';
import CompanyName from 'components/Common/Icons/CompanyName';
import SchoolinksLogo from 'components/Common/Icons/SchoolinksLogo';
import Avatar from 'components/Common/Layout/components/Avatar';
import HomeItem from 'components/Common/Layout/components/HomeItem';
import PageDetailsContainer from 'components/Common/LayoutV2/AppBar/PageDetails/PageDetailsContainer';
import {
  getRelevantNavItems,
  isElementaryPage,
} from 'components/Common/LayoutV2/utils';
import SupportLink from 'components/Common/SupportLink';
import Tooltip from 'components/Common/Tooltip';
import LogoutIcon from 'components/CommonV2/Icons/Logout';

import { SUPPORT_URL } from 'config_app';

import withRouter from 'containers/withRouter';
import { RouterPropTypes } from 'propTypes/RouterPropTypes';
import {
  ACCOUNT_SETTINGS_AFFILIATIONS,
  MESSAGES,
  NOTIFICATIONS,
  PROFILE_EDIT,
  ACCOUNT_SETTINGS_ACCOUNT_ACCESS,
  LOGOUT,
  LOGIN,
  ROOT,
  LOGIN_K12,
  ONBOARDING,
  CREDENTIAL_WALLET,
  DOCUMENT_CENTER,
} from 'routes/constants';

import getFullName from 'utils/getFullName';

import K12DashboardSwitcher from 'modules/AccountSetupV2/widgets/K12DashboardSwitcher';
import * as notificationActions from 'modules/Notifications/actions';
import UnifiedNotifications from 'modules/Notifications/UnifiedNotifications';
import StudentDemoAccount from 'modules/StudentDemoAccount';
import WelcomeWidget from 'modules/WelcomeWidget';

import v from 'components/variables';

import s from './MobileAppbar.css';

@withRouter
@connect(
  ({
    user: {
      profilePic,
      firstName,
      lastName,
      preferredName,
      featureOnboarding,
      layout = {},
      activeUserType = [],
      currentUserMode,
    },
    notifications: { unseenCount },
  }) => ({
    profilePic: profilePic ? `${profilePic}` : undefined,
    firstName,
    lastName,
    preferredName,
    featureOnboarding,
    appBar: getRelevantNavItems(
      layout,
      activeUserType,
      'appBar',
      currentUserMode,
    ),
    shouldRenderAffiliationLink:
      !activeUserType?.includes('member') &&
      activeUserType?.includes('guardian'),
    unseenCount,
  }),
  dispatch => bindActionCreators({ ...notificationActions }, dispatch),
)
@withState('helpExpanded', 'setHelpExpanded', false)
@withState('anchorEl', 'setAnchorEl', null)
@withState('hasK12DashboardSwitcher', 'setHasK12DashboardSwitcher', false)
export default class MobileAppbar extends Component {
  shouldComponentUpdate(nextProps, nextStates) {
    return !isEqual(nextProps, this.props) || !isEqual(nextStates, this.state);
  }

  handleMenuOpen = e => {
    const { setAnchorEl } = this.props;
    setAnchorEl(e.currentTarget);
  };

  handleMenuClose = () => {
    const { setAnchorEl } = this.props;
    setAnchorEl(null);
  };

  renderLogo = () => (
    <HomeItem key="home" linkTo={ROOT} style={{ height: 40, width: 40 }} />
  );

  renderStudentDemoButton = () => (
    <StudentDemoAccount key="student-demo" isMobile />
  );

  renderPageDetails = () => {
    const {
      appBarPageDetails,
      user: { isLoggedIn },
    } = this.props;
    const { title, modal, module, classes, hasFeatureOnboarding } =
      appBarPageDetails;

    if (!isLoggedIn) {
      return null;
    }

    return (
      <PageDetailsContainer
        title={title}
        module={module}
        modal={modal}
        classes={classes}
        hasFeatureOnboarding={hasFeatureOnboarding}
      />
    );
  };

  setHasK12DashboardSwitcher = () => {
    const { hasK12DashboardSwitcher, setHasK12DashboardSwitcher } = this.props;
    if (!hasK12DashboardSwitcher) {
      setHasK12DashboardSwitcher(true);
    }
  };

  renderDashboardSwitcher = () => {
    const {
      router: { location },
    } = this.props;

    return (
      <K12DashboardSwitcher
        isCurrentlyElementaryPage={isElementaryPage(location.pathname)}
        setHasK12DashboardSwitcher={this.setHasK12DashboardSwitcher}
      />
    );
  };

  renderStudentDemoText = () => (
    <div className={s.demoStudentText}>
      You are currently in <br />
      Student Demo Mode.
    </div>
  );

  renderAffiliationLink = () => (
    <NavLink to={ACCOUNT_SETTINGS_AFFILIATIONS} className={s.menuItemWrap}>
      <FontAwesomeIcon icon={faGraduationCap} />
      <div>
        <div>Join the Alumni/</div>
        <div>Professional Network</div>
      </div>
    </NavLink>
  );

  renderChatSupport = () => (
    <div
      className={cn('intercom-launcher', s.menuItem)}
      role="button"
      tabIndex={0}
    >
      <FontAwesomeIcon icon={faComment} />
      Chat Support
    </div>
  );

  renderDocumentsButton = () => (
    <NavLink key="documentCenter" className={s.menuItem} to={DOCUMENT_CENTER}>
      <FontAwesomeIcon icon={faFile} /> Document Center
    </NavLink>
  );

  renderCredentialWalletButton = () => (
    <NavLink
      key="credential-wallet"
      className={s.menuItem}
      to={CREDENTIAL_WALLET}
    >
      <FontAwesomeIcon icon={faWallet} /> Credential Wallet
    </NavLink>
  );

  renderMessage = item =>
    item.isEnabled ? (
      <NavLink key="messages" className={s.menuItem} to={MESSAGES}>
        <FontAwesomeIcon icon={faEnvelope} /> Messages{' '}
        <UnifiedNotifications
          showCount
          showMessageDot
          style={{ top: 16, right: 16 }}
        />
      </NavLink>
    ) : (
      <Tooltip
        placement="bottom"
        title="Messages is disabled in Student Demo Mode"
      >
        <div key="demo-messages" className={s.disabledMenuItem}>
          <FontAwesomeIcon icon={faEnvelope} /> Messages
        </div>
      </Tooltip>
    );

  renderNotification = () => {
    const { unseenCount, markAllNotificationSeen } = this.props;
    return (
      <NavLink
        key="notifications"
        className={s.menuItem}
        to={NOTIFICATIONS}
        onClick={async () => {
          if (unseenCount > 0) {
            await markAllNotificationSeen();
          }
        }}
      >
        <FontAwesomeIcon icon={faBell} /> Notifications{' '}
        <UnifiedNotifications
          showCount
          showNotificationDot
          style={{ top: 16, right: 16 }}
        />
      </NavLink>
    );
  };

  renderSettingsItems = () => {
    const {
      user: { firstName, lastName, preferredName, isStudent, profilePic },
    } = this.props;

    const fullName = getFullName({ firstName, lastName, preferredName });

    return (
      <>
        {isStudent ? (
          <NavLink
            key="profile"
            className={cn(s.avatar, s.menuItem)}
            to={PROFILE_EDIT}
          >
            <Avatar
              className={s.avatar}
              profilePic={profilePic}
              name={fullName}
              firstName={firstName}
              lastName={lastName}
            />{' '}
            Profile
          </NavLink>
        ) : null}
      </>
    );
  };

  renderHelpIcon = () => {
    const {
      user: { isCounselor },
      helpExpanded,
      setHelpExpanded,
    } = this.props;
    return isCounselor ? (
      <>
        <ClickableComponent
          className={s.menuItem}
          onClick={() => setHelpExpanded(!helpExpanded)}
        >
          <div className={s.helpText}>
            <FontAwesomeIcon icon={faCircleQuestion} />
            Need Help?
            <FontAwesomeIcon
              icon={faChevronDown}
              rotation={helpExpanded ? 180 : 0}
              className={s.chevron}
            />
          </div>
        </ClickableComponent>
        <Collapse in={helpExpanded}>
          <div className={s.helpItems}>
            <WelcomeWidget key="internal-helper" />
          </div>
        </Collapse>
      </>
    ) : (
      <div className={s.menuItem} key="help-icon">
        <SupportLink
          variant="hyperlink"
          hyperlinkColor="black"
          text={
            <div className={s.helpText}>
              <FontAwesomeIcon icon={faCircleQuestion} />
              Help Center
            </div>
          }
          url={SUPPORT_URL}
        />
      </div>
    );
  };

  renderLoginItems = () => {
    const {
      user: { isLoggedIn },
    } = this.props;

    return isLoggedIn ? (
      <>
        <NavLink
          key="settings"
          className={s.menuItem}
          to={ACCOUNT_SETTINGS_ACCOUNT_ACCESS}
        >
          <FontAwesomeIcon icon={faGear} /> Settings
        </NavLink>
        {this.renderChatSupport()}
        <NavLink key="logout" className={s.menuItem} to={LOGOUT}>
          <LogoutIcon />
          Logout
        </NavLink>
      </>
    ) : (
      <>
        <NavLink key="login" className={s.menuItem} to={LOGIN}>
          Login
        </NavLink>
      </>
    );
  };

  renderMemberButton = () => {
    const {
      user: { type },
      appBarPageDetails,
    } = this.props;

    return type === 'guest' ? (
      <Flexbox alignItems="center">
        <SchoolinksLogo className={s.logo} />
        {!appBarPageDetails?.hideName && (
          <CompanyName className={s.companyName} />
        )}
      </Flexbox>
    ) : null;
  };

  renderMemberLogin = () => {
    const {
      appBarPageDetails,
      user: { type },
    } = this.props;

    const { memberButtonHref, loginRedirect, hideSignUp } = appBarPageDetails;

    // AccountSetupScreen checks query params for redirecting after creating account - can use memberButtonHref to pass params
    const href = memberButtonHref || ONBOARDING;

    return type === 'guest' ? (
      <Flexbox gap={2} marginLeft="auto">
        <Button
          onClick={() => {
            window.location.href = LOGIN_K12;
            if (loginRedirect) {
              localStorage.setItem('loginRedirectURL', loginRedirect);
            }
          }}
          className={s.memberButton}
          variant="outlined"
          label="Log in"
        />
        {!hideSignUp && (
          <ButtonLink
            onClick={() => {
              window.location.href = href;
              if (loginRedirect) {
                localStorage.setItem('loginRedirectURL', loginRedirect);
              }
            }}
            className={s.signUpButton}
            variant="filled"
            label="Sign up"
          />
        )}
      </Flexbox>
    ) : null;
  };

  getAppBarMiddleItem = allKeys => {
    const { hasK12DashboardSwitcher } = this.props;

    if (hasK12DashboardSwitcher) {
      return null;
    }

    return (
      (allKeys.some(({ key }) => key === 'app-bar-page-details') &&
        this.renderPageDetails()) ||
      (allKeys.some(({ key }) => key === 'app-bar-demo-student-text') &&
        this.renderStudentDemoText()) ||
      (allKeys.some(({ key }) => key === 'app-bar-home') &&
        this.renderLogo()) ||
      (allKeys.some(({ key }) => key === 'app-bar-member') &&
        this.renderMemberButton())
    );
  };

  render() {
    const {
      user: { isLoggedIn, type },
      color,
      toggleAppbar,
      sideNav,
      appBar,
      shouldRenderAffiliationLink,
      appBarPageDetails,
    } = this.props;
    const { anchorEl } = this.props;
    const open = Boolean(anchorEl);

    const { left: leftKeys = [], right: rightKeys = [] } = { ...appBar };
    const allKeys = [
      shouldRenderAffiliationLink && { key: 'app-bar-affiliation-link' },
      ...(leftKeys || []),
      ...(rightKeys || []),
    ];

    if (!isEmpty(appBarPageDetails)) {
      allKeys.push({ key: 'app-bar-page-details' });
      if (appBarPageDetails.isPublicMemberPage) {
        allKeys.push({ key: 'app-bar-member' });
      }
    }

    const getAppBarItem = item =>
      ({
        'app-bar-credential-wallet': () => this.renderCredentialWalletButton(),
        'app-bar-documents': () => this.renderDocumentsButton(item),
        'app-bar-message': () => this.renderMessage(item),
        'app-bar-notification': () => this.renderNotification(),
        'app-bar-welcome-widget': () => this.renderHelpIcon(),
        'app-bar-affiliation-link': () => this.renderAffiliationLink(),
        'app-bar-demo-student-button': () => this.renderStudentDemoButton(),
        'app-bar-member': () => this.renderMemberButton,
      })[item.key];

    return (
      <AppBar
        position="fixed"
        style={{
          backgroundColor: v[`${color}Dark`],
        }}
      >
        <Toolbar
          classes={{
            root: s.customToolbar,
          }}
        >
          {isLoggedIn && (
            <IconButton
              className={s.menuButton}
              color="inherit"
              onClick={() => toggleAppbar()}
              style={{ ...(sideNav ? {} : { visibility: 'hidden' }) }}
            >
              <FontAwesomeIcon icon={faBars} />
            </IconButton>
          )}
          <div>
            {this.renderDashboardSwitcher()}
            {this.getAppBarMiddleItem(allKeys)}
          </div>

          {type !== 'guest' ? (
            <div>
              <IconButton
                className={s.moreIcon}
                color="inherit"
                onClick={this.handleMenuOpen}
              >
                <FontAwesomeIcon icon={faEllipsisVertical} />
                <UnifiedNotifications
                  showCount
                  showMessageDot
                  showNotificationDot
                  style={{ top: 10, right: -4 }}
                />
              </IconButton>
              <Popover
                classes={{
                  paper: s.dropdownPaper,
                }}
                open={open}
                anchorEl={anchorEl}
                onClose={this.handleMenuClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
              >
                {allKeys.find(({ key }) => key === 'app-bar-settings')
                  ? this.renderSettingsItems()
                  : null}

                {allKeys.map(item => {
                  const appBarItem = getAppBarItem(item);
                  if (typeof appBarItem === 'function') return appBarItem();
                  return null;
                })}
                {this.renderLoginItems()}
              </Popover>
            </div>
          ) : (
            this.renderMemberLogin()
          )}
        </Toolbar>
      </AppBar>
    );
  }
}

MobileAppbar.propTypes = {
  appBarPageDetails: shape({
    isPublicMemberPage: bool,
    memberButtonHref: string,
    loginRedirect: shape({}),
    hideSignUp: bool,
  }),
  router: RouterPropTypes,
  user: shape({}).isRequired,
  helpExpanded: bool,
  setHelpExpanded: func.isRequired,
  anchorEl: node.isRequired,
  setAnchorEl: func.isRequired,
  hasK12DashboardSwitcher: bool.isRequired,
  setHasK12DashboardSwitcher: func.isRequired,
  color: string.isRequired,
  toggleAppbar: func.isRequired,
  sideNav: bool.isRequired,
  appBar: shape({}).isRequired,
  shouldRenderAffiliationLink: bool.isRequired,
  unseenCount: number.isRequired,
  markAllNotificationSeen: func.isRequired,
};

MobileAppbar.defaultProps = {
  /**
   * @param isPublicMemberPage - If true, show app-bar-member
   * @param memberButtonHref - Url for onboarding when user presses sign up
   * @param loginRedirect - Redirects users after logging in (LoginRedirect). Needs to be in correct object shape for hooks/useRedirect
   * @param hideSignUp - If true, hides sign up button
   */
  appBarPageDetails: {
    isPublicMemberPage: false,
    memberButtonHref: undefined,
    loginRedirect: undefined,
    hideSignUp: false,
  },
  router: undefined,
  helpExpanded: false,
};
